import { useErrorNotifier } from "components/instrumentation/source";
import { useExperiments } from "components/store/source/context/ExperimentsContext";

import { DISABLE_AVAILABILITY_SECTION } from "types/experiments";

export const useDisableAvailabilitySection = () => {
  const { getExperiment } = useExperiments();
  const errorNotifier = useErrorNotifier();

  try {
    const experiment = getExperiment(DISABLE_AVAILABILITY_SECTION);
    if (!experiment) {
      return false;
    }

    return experiment?.value === "on";
  } catch (error) {
    errorNotifier.notify(
      error?.message ??
        `Failed to get ${DISABLE_AVAILABILITY_SECTION} experiment`,
    );
    return false;
  }
};
